import * as React from 'react';
import { SecondaryTileLabeledInputContext } from './secondary-tile.context.js';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';
import { useId } from '../../hooks/use-id.js';

/**
 * @subcomponent SecondaryTile
 * @deprecated Use Standard Tile instead, which provides a better user experience.
 */ const SecondaryTileLabeledInputLabel = deprecatedComponent({
    displayName: 'SecondaryTileLabeledInputLabel',
    description: 'SecondaryTileLabeledInputLabel is deprecated; use Standard Tile instead, which provides a better user experience.',
    root: createComponent({
        displayName: 'SecondaryTileLabeledInputLabel',
        root: 'label',
        propConfig: {
            classNames: [
                'swan-secondary-tile-labeled-input-label'
            ],
            processProps (props) {
                const { setLabelId } = useNonNullishContext(SecondaryTileLabeledInputContext);
                const { id } = props;
                const customId = useId(id);
                React.useEffect(()=>{
                    setLabelId(customId);
                    return ()=>setLabelId(undefined);
                }, [
                    customId,
                    setLabelId
                ]);
                return props;
            }
        }
    })
});

export { SecondaryTileLabeledInputLabel };
